function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Link from 'components/Link';
import messages from 'modules/App/messages';
import ChevronRight from 'svg/chevron-right.svg';
var _React_Component;
class BackButton extends (_React_Component = React.Component) {
    render() {
        return /*#__PURE__*/ _jsx("div", {
            className: "backButtonContainer",
            children: /*#__PURE__*/ _jsxs(Link, _object_spread_props(_object_spread({
                className: "backButton"
            }, this.props), {
                children: [
                    /*#__PURE__*/ _jsx(ChevronRight, {
                        className: "backArrow"
                    }),
                    /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.buttons.back))
                ]
            }))
        });
    }
}
_define_property(BackButton, "propTypes", {
    to: PropTypes.string.isRequired,
    onClick: PropTypes.func
});
export default BackButton;
